import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { version as versionJSON } from '../../../package.json';

const AppUpdater = () => {
  const [isActive, setIsActive] = useState(true);

  useEffect(() => {
    const updaterTimeout = process.env.REACT_APP_TIMER_UPDATER_TIMEOUT || 30 * 60 * 1000; // every 30 minutes if not set
    const timer =
      isActive &&
      setInterval(async () => {
        await checkVersion();
      }, updaterTimeout);

    return () => isActive && clearInterval(timer);
  }, [isActive]);

  useEffect(() => {
    window.addEventListener('focus', eventFocus);
    window.addEventListener('blur', eventBlur);

    return () => {
      window.removeEventListener('focus', eventFocus);
      window.removeEventListener('blur', eventBlur);
    };
  }, []);

  const eventFocus = async () => {
    setIsActive(true);
    await checkVersion();
  };

  const eventBlur = () => {
    setIsActive(false);
  };

  const checkVersion = async () => {
    try {
      if (isActive) {
        const salt = Math.random()
          .toString(36)
          .replace(/[^a-z]+/g, '')
          .substr(0, 5);
        const url = process.env.REACT_APP_URL + 'version.json?' + salt;
        const version = await axios.get(url);
        if (version?.data?.version !== versionJSON) {
          emptyCache();
        }
      }
    } catch (e) {
      console.log('Check version failed.');
    }
  };

  const emptyCache = () => {
    if ('caches' in window) {
      caches.keys().then((names) => {
        // Delete all the cache files
        names.forEach((name) => {
          caches.delete(name);
        });
      });

      // Makes sure the page reloads. Changes are only visible after you refresh.
      window.location.reload(true);
    }
  };

  return null;
};

export default AppUpdater;
